import React from "react";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import NavbarLogo from "../../image/icon/navbar-logo.png";
// import MainLogo from "../images/sos_logo.png";
import InstagramLogoLarge from "../../image/icon/instagram-logo-new.png";
import TwitterLogoLarge from "../../image/icon/twitter-logo-new.png";
import FacebookLogoLarge from "../../image/icon/facebook-logo-new.png";
import linkedin from "../../image/icon/linkedin.png";
import youtube from "../../image/icon/youtube.png";
import newlogo from "../../image/logo/Logo.png";

import "./NewNavbar.css";

import Chatbot from "react-chatbot-kit";
import "react-chatbot-kit/build/main.css";
import config from "../chatbot/config";
import ActionProvider from "../chatbot/ActionProvider";
import MessageParser from "../chatbot/MessageParser";
import TopBar from "../TopMenu/Topbar";


const NewNavbar = (props) => {
  const { handleClick } = props;
  const [showChat, setShowChat] = useState(false);
  const [navbarHide, setNavbarHide] = useState(true);
  const handleKnowMore = () => {
    handleClick();
  };
  const handleLogin = () => {
    handleClick('login');
  };

  const toggleNavbar = () => {
    console.log("toggleNavbar");
    setNavbarHide(!navbarHide);
  };

  return (
    <>
    <div className="topmenucontainer">
    <TopBar />
    </div>
    <div className="navbarwrapper">
      
      
       <div>
      {/* Floating Button */}
      {!showChat && (
        <>
        <div
        className="d-none d-md-block slide-load"
        style={{
          position: "fixed",
          bottom: "20px",
          textAlign: "center",
          right: "26px",
          borderRadius: "3% 17% 19% 3%",          
          backgroundColor: "rgb(37, 99, 235)",
          color: "white",
          border: "none",
          cursor: "pointer",
          fontSize: "1.2em",
          boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 8px",
          zIndex:15,
          padding: "4px 4% 3px 1%",
          transition: "transform 0.5s ease-in-out",
        }}
        onClick={() => setShowChat(true)}
        ><strong>👋 Hi I am nova</strong> <br/> <small>how may i help you today?</small></div>
        <button
        className="slide-load"
          onClick={() => setShowChat(true)}
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            borderRadius: "50%",
            width: "60px",
            height: "60px",
            backgroundColor: "#2563eb", // Tailwind blue-600
            color: "white",
            border: "none",
            cursor: "pointer",
            fontSize: "20px",
            boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
            zIndex:15,
          }}
        >
          💬
        </button>
        </>
      )}

      {/* Chatbot */}
      {showChat && (
        <div
          style={{
            position: "fixed",
            bottom: "80px",
            right: "20px",
            width: "320px",
            height: "500px",
            zIndex: 1000,
          }}
        >
          <button
            onClick={() => setShowChat(false)}
            style={{
              padding: "12px",
              color: "#1e9ad6",
              border: "none",
              cursor: "pointer",
              zIndex: "9",
              right: "0",
              fontWeight:900,
              position:"absolute",
            }}
          >
            X
          </button>
          <Chatbot
            config={config}
            messageParser={MessageParser}
            actionProvider={ActionProvider}
            headerText='HGS NOVA'
          />
          
        </div>
      )}
    </div>


      <div className="topheader d-none d-md-block mb-0">
      <div className="topheaderleft"><Link to="/" className="navbarItem"><img className="" src={newlogo} alt="" /></Link></div>
      <div className="topheaderright"><h1>HGS Faridabad</h1></div>

      </div>
      <div className="navbarContainer">
        <div data-aos="fade" className="navbarLarge">
          {/* <Link to="/home" className="h-14">
          <img className="h-full" src={MainLogo} alt="SOS" />
        </Link> */}
          <div
            className="d-flex d-lg-none justify-content-center align-items-center"
            onClick={toggleNavbar}
          >
            <img className="mobile-top-logo d-block d-md-none" src={newlogo} alt="" />
            <h6 className="d-block d-md-none">
              HGS Faridabad
            </h6>
            <div className="mobileToggleIcon">
              <img className="h-100" src={NavbarLogo} alt="" />
            </div>
          </div>
          <div className="navbarItems">
            <Link to="/" className="navbarItem">
              Home
            </Link>
            <span>|</span>
            <Link to="/mandatory-disclosures" className="navbarItem">
              Mandatory Disclosure
            </Link>            
            <span>|</span>
            <p onClick={handleKnowMore} className="navbarItem mb-0 ">
              Know More
            </p>
            <span>|</span>
            <Link to="/contact-us" className="navbarItem">
              Contact Us
            </Link>
            <span>|</span>
            <Link to="/blogs" className="navbarItem">
              Blogs
            </Link>
            {/* <span>|</span>
            <Link to="/gallery" className="navbarItem">
              Gallery
            </Link>
            <span>|</span> */}
            <div class="login-wrapper">

            <p className="navbarItem mb-0 login ">
              Login
            </p>
            <div className="loginmenu">
              <Link to="/parent-login" className="navbarItem">
                Parent Login
              </Link>
              <br />
              <Link to="/student-login" className="navbarItem">
                Students Login
              </Link>
              <br />
              <Link to="/Fees-payment" className="navbarItem">
                Fees-Payment
              </Link>            
            </div>
            </div>
            {/* <span>|</span>
            <Link to="/book-tour" className="navbarItem">
              Book a Tour
            </Link> */}
            <span>|</span>
            <div className="d-flex">
              <div className="socialIconLarge d-flex">
                <img
                  className="h-100"
                  src={FacebookLogoLarge}
                  alt=""
                  onClick={() =>
                    window.open(
                      "https://web.facebook.com/hermann.gmeiner.9279",
                      "_blank"
                    )
                  }
                />
              </div>
              <div className="socialIconLarge d-flex">
                <img
                  className="h-100"
                  src={InstagramLogoLarge}
                  alt=""
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/hgsfaridabad/",
                      "_blank"
                    )
                  }
                />
              </div>
              <div className="socialIconLarge d-flex">
                <img
                  className="h-100"
                  src={TwitterLogoLarge}
                  alt=""
                  onClick={() =>
                    window.open("https://twitter.com/HGS_Faridabad", "_blank")
                  }
                />
              </div>
              <div className="socialIconLarge d-flex me-0">
                <img
                  className="h-100"
                  src={youtube}
                  alt=""
                  onClick={() =>
                    window.open(
                      "https://www.youtube.com/channel/UCQMhAUB1PDxHQ3toSnp4-qA",
                      "_blank"
                    )
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          "navbarSmall" + (navbarHide ? " custom-right-full" : " end-0")
        }
      >
        <div className="mobileToggle" onClick={toggleNavbar}></div>
        <div className="navMobileItems">
          <Link to="/" className="navMobileItem" onClick={toggleNavbar}>
            Home
          </Link>
          <Link
            to="/mandatory-disclosures"
            className="navMobileItem"
            onClick={toggleNavbar}
          >
            Mandatory Disclosure
          </Link>
          <Link to="/Blogs" className="navMobileItem" onClick={toggleNavbar}>
            Blogs
          </Link>
          <Link
            to="/parent-login"
            className="navMobileItem"
            onClick={toggleNavbar}
          >
            Parent Login
          </Link>
          <p onClick={handleKnowMore} className="navMobileItem">
            Know More
          </p>
          <Link
            to="/contact-us"
            className="navMobileItem"
            onClick={toggleNavbar}
          >
            Contact Us
          </Link>
          {/* <Link
            to="/book-tour"
            className="navMobileItem"
            onClick={toggleNavbar}
          >
            Book a Tour
          </Link> */}
          <div className="mobileSocialContainer">
            <div className="mobileSocialIcon">
              <img
                className="h-100"
                src={FacebookLogoLarge}
                alt=""
                onClick={() =>
                  window.open(
                    "https://web.facebook.com/hermann.gmeiner.9279",
                    "_blank"
                  )
                }
              />
            </div>
            <div className="mobileSocialIcon">
              <img
                className="h-100"
                src={InstagramLogoLarge}
                alt=""
                onClick={() =>
                  window.open(
                    "https://www.instagram.com/hgsfaridabad/",
                    "_blank"
                  )
                }
              />
            </div>
            <div className="mobileSocialIcon">
              <img
                className="h-100"
                src={TwitterLogoLarge}
                alt=""
                onClick={() =>
                  window.open("https://twitter.com/HGS_Faridabad", "_blank")
                }
              />
            </div>
            <div className="mobileSocialIcon">
              <img
                className="h-100"
                src={youtube}
                alt=""
                onClick={() =>
                  window.open(
                    "https://www.youtube.com/channel/UCQMhAUB1PDxHQ3toSnp4-qA",
                    "_blank"
                  )
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default NewNavbar;
